import { Fragment, useEffect, useState } from 'react';
import {
  Grid,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  Table,
  TableHead,
} from '@mui/material';
import MuiRadioGroup from './components/MuiRadioGroup';

import { IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';
import { StyledTableCellTwo } from 'routes/Main/style';
import { Stack } from '@mui/system';

interface Props extends IFormValues, IFormWatch {
  disabled?: boolean;
  setSum3: (sum3: number) => void;
}

const Contents3 = (props: Props) => {
  const { disabled, getValues, setValue, setSum3 } = props;

  const [num01, setNum01] = useState(
    getValues('kdsq_c_11') ? getValues('kdsq_c_11') : 0
  );
  const [num02, setNum02] = useState(
    getValues('kdsq_c_12') ? getValues('kdsq_c_12') : 0
  );
  const [num03, setNum03] = useState(
    getValues('kdsq_c_13') ? getValues('kdsq_c_13') : 0
  );
  const [num04, setNum04] = useState(
    getValues('kdsq_c_14') ? getValues('kdsq_c_14') : 0
  );
  const [num05, setNum05] = useState(
    getValues('kdsq_c_15') ? getValues('kdsq_c_15') : 0
  );

  useEffect(() => setSum3(num01 + num02 + num03 + num04 + num05));

  return (
    <Fragment>
      <SectionTitle title="ADL (KDSQ-A)" />

      <Grid item xs={12}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <StyledTableCellTwo
                colSpan={1}
                sx={{
                  padding: '16px',
                  whiteSpace: 'nowrap',
                  fontSize: '12px',
                }}
              ></StyledTableCellTwo>
              <StyledTableCellTwo
                colSpan={1}
                align="center"
                sx={{
                  fontSize: '12px',
                  paddingLeft: '30px',
                }}
              >
                <Stack direction="row" gap={16.5}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
                    아니다(0점)
                  </Typography>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
                    가끔 그렇다(1점)
                  </Typography>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
                    자주 그렇다(2점)
                  </Typography>
                </Stack>
              </StyledTableCellTwo>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                  }}
                  maxHeight={20}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  11. 이전에 잘 다루던 기구의 사용이 서툴러졌다. (세탁기,
                  전기밥솥, 경운기 등)
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'left', paddingLeft: '50px' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  values={[0, 1, 2]}
                  defaultValue={getValues('kdsq_c_11')}
                  onChange={v => {
                    setValue('kdsq_c_11', Number(v));
                    setNum01(Number(v));
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                  }}
                  maxHeight={50}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  12. 예전에 비해 방이나 집안의 정리 정돈을 하지 못한다.
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'left', paddingLeft: '50px' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  values={[0, 1, 2]}
                  defaultValue={getValues('kdsq_c_12')}
                  onChange={v => {
                    setValue('kdsq_c_12', Number(v));
                    setNum02(Number(v));
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    width: '500px',
                  }}
                  maxHeight={20}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  13. 상황에 맞게 스스로 옷을 선택하여 입지 못 한다.
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'left', paddingLeft: '50px' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  values={[0, 1, 2]}
                  defaultValue={getValues('kdsq_c_13')}
                  onChange={v => {
                    setValue('kdsq_c_13', Number(v));
                    setNum03(Number(v));
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    width: '500px',
                  }}
                  maxHeight={20}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  14. 혼자 대중교통을 이용하여 목적지에 가기 힘들다. (신체적인
                  문제(관절염)로 인한 것은 제외됨.)
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'left', paddingLeft: '50px' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  values={[0, 1, 2]}
                  defaultValue={getValues('kdsq_c_14')}
                  onChange={v => {
                    setValue('kdsq_c_14', Number(v));
                    setNum04(Number(v));
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    width: '500px',
                  }}
                  maxHeight={20}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  15. 내복이나 옷이 더러워져도 갈아입지 않으려고 한다.
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'left', paddingLeft: '50px' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  values={[0, 1, 2]}
                  defaultValue={getValues('kdsq_c_15')}
                  onChange={v => {
                    setValue('kdsq_c_15', Number(v));
                    setNum05(Number(v));
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Grid>
    </Fragment>
  );
};

export default Contents3;
